import type { ClientPropertyItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { propertyValue } from "web_myplann/Portfolio/Components/Redesign/ListItem/propertyHelpers";

export const propertyNumericValue = (
	data: ClientPropertyItemResponseDTO,
): number | null => {
	const raw = propertyValue(data);
	if (raw === null || raw.trim() === "") {
		return null;
	}
	const parsed = Number(raw);
	return Number.isFinite(parsed) ? parsed : null;
};
